import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import useFetchOptions from "../hooks/use-fetch-options.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { causeOptions  } = useFetchOptions();

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4!'}>

                        <InputDateTime
                            id="dtStart"
                            label="Data/hora inicial *"
                            selected={filters.dtStart ? new Date(filters.dtStart) : null}
                            onChange={(date) => setFilters(prev => ({...prev, dtStart: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />

                        <InputDateTime
                            id="dtEnd"
                            label="Data/hora final *"
                            selected={filters.dtEnd ? new Date(filters.dtEnd) : null}
                            onChange={(date) => setFilters(prev => ({...prev, dtEnd: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />

                        <InputDateTime
                            id="dtFactStart"
                            label="Data/hora do início do fato"
                            selected={filters.dtFactStart ? new Date(filters.dtFactStart) : null}
                            onChange={(date) => setFilters(prev => ({...prev, dtFactStart: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />

                        <InputDateTime
                            id="dtFactEnd"
                            label="Data/hora do fim do fato"
                            selected={filters.dtFactEnd ? new Date(filters.dtFactEnd) : null}
                            onChange={(date) => setFilters(prev => ({...prev, dtFactEnd: date}))}
                            classNameWrapper={"w-full"}
                            dateFormat="LL"
                        />

                        <SelectComponent
                            label='Motivo'
                            isMulti={true}
                            wrapValues={true}
                            options={causeOptions}
                            value={filters.cause}
                            onChange={(value) => setFilters(prev => ({...prev, cause: value}))}
                            instanceId="cause"
                            classNameWrapper={"w-full"}
                        />

                </form>
            </div>
        </>
    );
};

export default Filters;